module.exports = __webpack_public_path__ + "img/LogoExitusCredit_Gris.b45104e5.png";